<ng-template #content>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
            (click)="modalRef.dismiss('Cross click')" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="title" i18n="parameters-checkList|@@classes">Ajouter un élément</span>
        </div>
      </div>

      <ng-container *ngIf="vehicle.classes && vehicle.classes[0]">
        <div class="row generalrows">
          <div class="col-5 center">
            <span class="span-txt" i18n="parameters-checkList|@@name">Nom : </span>
          </div>
          <div class="col-5">
            <input type="text" placeholder="Nom" [(ngModel)]="newElement.display">
          </div>
        </div>
        <div class="row generalrows">
          <div class="col-5 center">
            <span class="span-txt" i18n="parameters-checkList|@@defaultvalue">Valeur par Defaut : </span>
          </div>
          <div class="col-2">
            <div class="parameters-toggle">
              <app-generic-toggle (sendData)='newElement.value = $event' [value]="newElement.value">
              </app-generic-toggle>
            </div>
          </div>
        </div>
        <div class="row generalrows" *ngFor="let report of reportsType">
          <div class="col-5 center">
            <span class="span-txt">Rapport {{report}} : </span>
          </div>
          <div class="col-2">
            <div class="parameters-toggle">
              <app-generic-toggle (sendData)='changetoggle("reportType", report, $event)'
                [value]="newElement.reportType.includes(report)">
              </app-generic-toggle>
            </div>
          </div>
        </div>
        <div class="row generalrows" *ngFor="let classId of vehicle.classes">
          <div class="col-5 center">
            <span class="span-txt">Classe {{classId.display}} : </span>
          </div>
          <div class="col-2">
            <div class="parameters-toggle">
              <app-generic-toggle (sendData)='changetoggle("classIds", classId.value, $event)'
                [value]="newElement.classIds.includes(classId.value)"></app-generic-toggle>
            </div>
          </div>
        </div>

      </ng-container>
      <div class="row" *ngIf="!vehicle.classes || !vehicle.classes[0]">
        Erreur : Il n'y a pas de classes
      </div>

    </div>
  </div>
  <div class="modal-footer ">
    <button type="button" class="btn btn-lg primary" *ngIf="newElement.display.length > 0 && this.newElement.id === null"
      (click)="addNewElement()" i18n="parameters-checkList|@@add">Ajouter</button>
    <button type="button" class="btn btn-lg primary" *ngIf="newElement.display.length > 0 && this.newElement.id !== null"
      (click)="addNewElement()" i18n="parameters-checkList|@@update">Modifier</button>
    <button type="button" *ngIf="newElement.display.length === 0 && this.newElement.id === null"
      class="btn btn-secondary btn-lg" i18n="parameters-checkList|@@add">Ajouter</button>
    <button type="button" *ngIf="newElement.display.length === 0 && this.newElement.id !== null"
      class="btn btn-secondary btn-lg" i18n="parameters-checkList|@@update">Modifier</button>
    <button type="button" class="btn btn-lg primary" (click)="modalRef.dismiss('Cross click')"
      i18n="parameters-checkList|@@close">Fermer</button>
  </div>
</ng-template>


<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-checkList|@@checkList">CheckList</span>
    </div>
  </div>
  <div class="row mt-0 mb-5">
    <div class="col-12">
      <div class="table-option-toggle">
        <div class="conatainer">
          <div class="row m-0 center-toggle">
            <div class="col-9">
              <span class="column-title" i18n="table-options-toggle|@@element">Element Name</span>
            </div>
          </div>
          <tbody >
            <tr class="checkliststyle" *ngFor="let checklist of  vehicle.checklist">
              <th scope="row" class="checklistText row m-0">
                {{checklist.display}}
              </th>
              <th >
                <div class="submenucontainer col-3">
                  <app-submenu [options]="submenuOptions"  (selectedOption)="handleSubmenuSelection($event, checklist.id)">
                    <button class="btn btn-lg secondary"><svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>Plus...</title>
                        <desc>Created with Sketch.</desc>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B" fill-rule="nonzero">
                            <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                              <g id="CTA" transform="translate(1050.000000, 23.000000)">
                                <g id="menu-dots"
                                  transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                                  <circle id="Oval" cx="8" cy="2" r="2"></circle>
                                  <circle id="Oval" cx="2" cy="2" r="2"></circle>
                                  <circle id="Oval" cx="14" cy="2" r="2"></circle>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg></button>
                  </app-submenu>
                </div>
              </th>
            </tr>
          </tbody>
        </div>
      </div>
    </div>
  </div>
  <div class="row report-form">
    <div class="col-12 d-flex">
      <button type="button" class="btn btn-lg primary ml-auto" (click)='open(null)'
        i18n="parameters-checkList|@@addnewelement">Ajouter un élément</button>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-check-list/parameters-check-list.component.html